module.exports = __webpack_public_path__ + "static/media/changelog.54ce5af7.md";